import { AccessRightFilterCollectionModel } from '@fi-shared/models';
import { PublicationSettingModel } from '@fi-shared/models';
import { DocumentSettingModel } from '@fi-app/document/document-setting.model';

export class MindMapImport {
    IsPublished = false;
    TemplateId = 1;
    FileContent = '';
    CreatedByUserId = undefined;
    CreatedByUserName = '';
    AccessRightFilterCollection = new AccessRightFilterCollectionModel();
    PublicationSetting = new PublicationSettingModel();
    DocumentSetting = new DocumentSettingModel();
}
